<template>
  <v-navigation-drawer v-model="toggled" app dark right class="text-right">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title"> Piximind </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list v-if="$store.getters.isAgent" dense nav>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="item.to"
        link
        :class="{ 'v-list-item--active': isItemActive(item) }"
        @click="$emit('toggled', false)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-content>
          <v-list-item-title>Déconnexion</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <v-list v-if="$store.getters.isAdmin" dense nav>
      <v-list-item
        v-for="item in adminItems"
        :key="item.title"
        :to="item.to"
        link
        :class="{ 'v-list-item--active': isItemActive(item) }"
        @click="$emit('toggled', false)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item link @click="logout">
        <v-list-item-content>
          <v-list-item-title>Déconnexion</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    toggled: {
      String,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      items: [
        {
          title: "TimeSheet",
          icon: "mdi-calendar",
          to: "/dashboard/timesheet",
        },
        {
          title: "Mon profile",
          icon: "mdi-account-box",
          to: "/dashboard/profile/photo",
          activePaths: ["/dashboard/profile/photo", "/dashboard/profile/password"]
        },
        {
          title: "Rapport projet",
          icon: "mdi-file-chart",
          to: "/dashboard/rapport",
        },
        {
          title: "Mes projets",
          icon: "mdi-view-dashboard",
          to: "/dashboard/projects",
        },
        {
          title: "Mes congés",
          icon: "mdi-calendar",
          to: "/dashboard/conge",
        },
      ],
      adminItems: [
        {
          title: "Tableau de bord",
          icon: "mdi-monitor-dashboard",
          to: "/dashboard/statistics",
          activePaths: ["/dashboard/statistics", "/dashboard/crosstab"]
        },
        {
          title: "Mon profile",
          icon: "mdi-account-box",
          to: "/dashboard/profile/photo",
          activePaths: ["/dashboard/profile/photo", "/dashboard/profile/password"]
        },
        {
          title: "Equipes",
          icon: "mdi-account-group",
          to: "/dashboard/ressources",
        },
        {
          title: "Projet",
          icon: "mdi-view-dashboard",
          to: "/dashboard/dossiers",
          activePaths: ["/dashboard/dossiers", "/dashboard/clients"]
        },
        {
          title: "Configuration des projets",
          icon: "mdi-cog",
          to: "/dashboard/dossier/config",
        },
        {
          title: "Time sheet",
          icon: "mdi-calendar",
          to: "/dashboard/timesheet/list",
          activePaths: ["/dashboard/timesheet/list", "/dashboard/timesheet/manquants", "/dashboard/timesheet/ignorer",
           "/dashboard/timesheet/prolongations", "/dashboard/timesheet/uploads"]
        },
        {
          title: "Timesheet Mensuel",
          icon: "mdi-calendar",
          to: "/dashboard/timesheetMensuel/list",
        },
        {
          title: "Rapports",
          icon: "mdi-file-chart",
          to: "/dashboard/rapport/list",
          activePaths: ["/dashboard/rapport/list", "/dashboard/rapport/types"]
        },
        {
          title: "Roles",
          icon: "mdi-account-box",
          to: "/dashboard/roles",
          activePaths: ["/dashboard/roles", "/dashboard/operations"]
        },
        {
          title: "Suivi des congés",
          icon: "mdi-calendar",
          to: "/dashboard/conge/follow",
        },
      ],
      right: null,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    isItemActive(item) {
      const current = this.$route.path;
      if (item.activePaths && Array.isArray(item.activePaths)) {
        return item.activePaths.some(p => current.startsWith(p));
      }
      return current.startsWith(item.to);
    }
  },
};
</script>
